import React, { Component } from 'react';
import { Line } from 'rc-progress';


export default class LineProgress extends Component {

    constructor(props) {
        super(props);

        this.state = {
            progress: 0,
        };
    }

    componentDidMount() {
        const { percent } = this.props;
        this.interval = setInterval(() => this.setState((prevState) => {
            if (prevState.progress < percent) {
                return { progress: ++prevState.progress };
            }

            clearInterval(this.interval);
            return { progress: prevState.progress };
        }), 5);
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    render() {
        const { percent, ...rest } = this.props;
        const { progress } = this.state;

        return (
            <Line
                trailWidth={3}
                trailColor="#E3E7EF"
                strokeWidth={3}
                strokeColor="#7740f9"
                percent={progress}
                {...rest}
            />
        );
    }

}
